import { Grid, Avatar } from "@mui/material";
import { getPositionLetter } from "./utils";

export default function Scoreboard({ data = [] }) {
  return (
    <>
      {data.map((row) => (
        <Grid container spacing={2} key={row.playerA} sx={{ my: 1 }}>
          <Grid item xs={1}>
            {row.scoreA}
          </Grid>
          <Grid item xs={4}>
            {row.playerA} {row.teamA ? `(${row.teamA})` : ""}
          </Grid>
          <Grid
            item
            xs={2}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ bgcolor: "#FF8C04" }}>
              {getPositionLetter(row.position)}
            </Avatar>
          </Grid>
          <Grid item xs={4}>
            {row.playerB} {row.teamB ? `(${row.teamB})` : ""}
          </Grid>
          <Grid item xs={1}>
            {row.scoreB}
          </Grid>
        </Grid>
      ))}
    </>
  );
}
